module.exports = __webpack_public_path__ + "static/media/icon-subtraction.34b72ce5.svg";